import React from 'react'
import { JotformState, initialJotformState } from '../../../../../../Modules/Shoppinger2.Jotform/Frontend/jotform.state'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { cookiePlaceholderClickable, cookiePlaceholderText } from '../../../../cookiebar/cookiebar.layout'
import { DP } from '../../../drupal/blockDefinitions'
import { AnchorProps, ModernBlock } from '../../modernBlocks.state'
import { JotformBlockLayout } from './jotformBlock.layout'
import { jotformBlockClasses } from './jotformBlock.style'
import { fieldUpdater } from '../../../../../../Shared/Frontend/utils/fieldUpdater'
import { jotformWidget } from '../../../../../../Modules/Shoppinger2.Jotform/Frontend/jotform.widget'

export type JotformBlock = {
  index: number
  title: string
  intro: string
  label: string
  useCookieBar: boolean
  excludeFromPageMenu?: boolean
  cookiePlaceholder?: JSX.Element | string
  cookieButton?: string
  inview?: { threshold?: number; triggerOnce?: boolean }
  formID: string
  formTitle?: string
  jotform: JotformState
} & AnchorProps

export const jotformBlock: ModernBlock<JotformBlock> = {
  kind: 'jotformBlock',
  render: (setRootState, rootState, blockIndex, blockProps) =>
    jotformWidget(blockProps.formID)(blockProps.jotform)
      .map(fieldUpdater<JotformBlock>()('jotform'))
      .wrapHTML((html:JSX.Element) => (
        <JotformBlockLayout label={blockProps.label} title={blockProps.title} intro={blockProps.intro}>
          {html}
        </JotformBlockLayout>
      )),
  adapters: {
    drupal: (dpBlock: DP.JotForm, blockIndex): JotformBlock | undefined => {
      const targetId = dpBlock.target.type[0].target_id
      if (targetId != 'jotforms') return undefined
      return {
        index: blockIndex,
        title: dpBlock.target.field_title[0]?.value,
        excludeFromPageMenu: dpBlock.target?.field_exclude_from_page_menu?.[0]?.value,
        intro: dpBlock.target.field_introduction[0]?.value,
        label: dpBlock.target.field_label[0]?.value,
        formID: dpBlock.target.field_form_id[0].value,
        formTitle: dpBlock.target.field_form_title?.[0]?.value,
        useCookieBar: true,
        cookieButton: cookiePlaceholderClickable('iframe'),
        cookiePlaceholder: cookiePlaceholderText('iframe'),
        inview: { threshold: 0.1, triggerOnce: true },
        anchorTitle: `jotform-${blockIndex}`,
        jotform: initialJotformState(dpBlock.target.field_form_id[0].value),
      }
    },
  },
  sampleExample: [],
  seoEvents: () => [
    {
      id: `io-jotform`,
      event: 'onMouseOver',
      category: 'jotform-wrapper',
      label: window.location.pathname,
      action: 'mouse over',
    },
  ],
  inView: {
    threshold: 0.75,
    triggerOnce: false,
    inViewClassName: getClassNameModern(jotformBlockClasses, 'inview', 'inview'),
    showAs: 'div',
    updateState: (currentInviewState, currentBlockState) => ({
      ...currentBlockState,
      inviewState: currentInviewState,
    }),
  },
  blockClassName: getClassNameModern(jotformBlockClasses, 'block', 'mb-6'),
}
